import React__default from 'react';

function returnWithoutFragment(children) {
  var result = [];
  React__default.Children.forEach(children, function (child) {
    if (typeof child === 'string' || typeof child === 'number') {
      result.push(child);
    } else if ( /*#__PURE__*/React__default.isValidElement(child)) {
      if (child.type === React__default.Fragment) {
        result = result.concat(returnWithoutFragment(child.props.children));
      } else {
        result.push(child);
      }
    }
  });
  return result;
}

export { returnWithoutFragment };
//# sourceMappingURL=comp.js.map
